import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button, Form, message, Modal, Select } from 'antd';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { OWButton } from '../ow_button/OWButton';
import {
	siteSurveysRestCrudThunksForBuyer,
	siteSurveysRestCrudThunksForSupplier,
} from '../../thunks/site_surveys_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const FORM_NAME = 'task-entity-form';
const WO_TASK_COLLECTION = 'woTasksCollection';

const WOTaskEntityAssociateModal: FC<any> = ({
	task,
	onCancel,
	workOrder,

	siteSurveys,
	getSiteSurveys,
	onSave,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const locationId = useMemo(() => nullSafeGet('locationId', workOrder), [workOrder]);

	const onSubmit = useCallback(
		(values) => {
			setSaving(true);
			onSave({
				...task,
				...values,
			})
				.then(() => {
					message.success('Associated successfully!');
					onCancel();
				})
				.catch(message.error)
				.finally(() => setSaving(false));
		},
		[onCancel, onSave, task]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={`Associate - ${task.title}`}
			onCancel={onCancel}
			closable={false}
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<OWButton
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={saving}
				>
					Save
				</OWButton>,
			]}
		>
			<Form id={FORM_NAME} layout="vertical" onFinish={onSubmit} initialValues={{ ...task }}>
				<Form.Item
					name="siteSurveyId"
					label="Site Survey"
					rules={[{ required: true, message: 'Please select a site survey.' }]}
				>
					<OWAsyncSelect
						style={{ maxWidth: 640 }}
						targetCollectionName={WO_TASK_COLLECTION}
						stateSlice={siteSurveys}
						fetchMultiple={(ids, targetCollectionName) => {}}
						fetchData={(
							search,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						) => {
							getSiteSurveys(
								{
									title: search || undefined,
									locationId,
								},
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							);
						}}
						renderRecord={(ss) => (
							<Select.Option key={ss.id} value={ss.id}>
								{ss.title}
							</Select.Option>
						)}
						sortBy={{ sort_by: 'name', order: 'ascend' }}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	siteSurveys: state.site_surveys,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSiteSurveys: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveysRestCrudThunksForSupplier.readLite(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: siteSurveysRestCrudThunksForBuyer.readLite(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
});

const TaskEntityAssociateModalWUT = connect(
	mapStateToProps,
	mapDispatchToProps
)(WOTaskEntityAssociateModal);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(TaskEntityAssociateModalWUT);
